export enum InvitationType {
    AGE_UP = 'AGE_UP',
    RECRUITMENT = 'RECRUITMENT'
}
